/* RESPONSIBLE TEAM: team-frontend-tech */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable @intercom/intercom/no-bare-strings */
export default {
  string: {
    comparison: [{
      label: 'has any value',
      value: 'known'
    }, {
      label: 'is',
      value: 'eq'
    }, {
      label: 'is not',
      value: 'ne'
    }, {
      label: 'starts with',
      value: 'starts_with',
      ignoreOptions: true
    }, {
      label: 'ends with',
      value: 'ends_with',
      selected: false,
      ignoreOptions: true
    }, {
      label: 'contains',
      value: 'contains',
      ignoreOptions: true
    }, {
      label: 'does not contain',
      value: 'not_contains',
      ignoreOptions: true
    }]
  }
};